import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import esLocale from "date-fns/locale/es";
import { Redirect } from "react-router-dom";
import DateFnsUtils from "@date-io/date-fns";
import { useForm } from "../../../hooks/useForm";
import {
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import {
  cleanAfiliadoSeleccionado,
  cleanRecetas,
  clearReducer,
  getContadoresRecetasHistorial,
  getRecetasHistorial,
  setEstadoRecetas
} from "../../../actions/recetasDigitales/RecetasDigitales";
import { RecetasDigitalesAfiliadoBuscador } from "../Ingreso/RecetasDigitalesAfiliadoBuscador";
import { RecetaItem } from "./RecetaItem";
import { OBRAS_SOCIALES, RECETAS_ESTADOS } from "../../../utils/constants";
import BuscadorMedicamento from "../Ingreso/BuscadorMedicamento";
const useStyles = makeStyles({
  root: {
    padding: 10,
    flexGrow: 1,
    marginTop: 10,
    // width: "100%",
  },
  input: {
    padding: 10,
  },
});
const stateInitial = {
  idProfesional: null,
  fechaInicio: null,
  fechaFin: null,
};
let arrayEstadosRecetas = [];

export const GestionHistorialRecetasHome = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    afiliadoSeleccionado,
    estadoRecetas,
    recetas: items,
    recetasContadores,
  } = useSelector((state) => state.recetasDigitales);
  const { areas = [], bandejasAutorizacion = [], permisos: permisosUser } = useSelector(
    (state) => state.auth
  );

  const [formValues, , , setearValor] = useForm(stateInitial);
  const [codigoMedicamento, setCodigoMedicamento] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [redirect, setRedirect] = useState(false);
  const { fechaInicio, fechaFin } = formValues;
  const [dense, setDense] = useState(true);
  const [page, setPage] = useState(0);
  const [idObraSocial, setIdObraSocial] = useState(OBRAS_SOCIALES.OSPEDYC);

  useEffect(() => {
    if (!props.location.state?.fromHomeScreen) {
      dispatch(clearReducer());
      dispatch(cleanRecetas());
      dispatch(cleanAfiliadoSeleccionado());
    }
  }, [dispatch]);

  useEffect(() => {
    arrayEstadosRecetas = Object.entries(RECETAS_ESTADOS);
  }, [areas, bandejasAutorizacion]);

  useEffect(() => {
    if (arrayEstadosRecetas.filter(s => s[1] === parseInt(estadoRecetas)).length > 0) {
      dispatch(
        getRecetasHistorial(
          afiliadoSeleccionado?.id_afiliado,
          codigoMedicamento?.idMedicamento,
          fechaInicio,
          fechaFin,
          parseInt(estadoRecetas),
          idObraSocial
        )
      );
      setPage(0);
    }
  }, [
    dispatch,
    afiliadoSeleccionado?.id_afiliado,
    codigoMedicamento,
    fechaInicio,
    fechaFin,
    estadoRecetas
  ]);

  useEffect(() => {
    dispatch(
      getContadoresRecetasHistorial(
        afiliadoSeleccionado?.id_afiliado,
        codigoMedicamento?.idMedicamento,
        fechaInicio,
        fechaFin,
        parseInt(estadoRecetas),
        idObraSocial
        )
    );
  }, [
    dispatch,
    afiliadoSeleccionado?.id_afiliado,
    codigoMedicamento,
    fechaInicio,
    fechaFin,
    estadoRecetas
  ]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const componentRef = React.useRef();

  return (
    <Grid container className={classes.root} justify="center" spacing={1}>
      <Grid item xs={12}>
        <Grid container direction="row" alignItems="center" spacing={1}>
          <Grid item xs={12} md={5}>
            <RecetasDigitalesAfiliadoBuscador idObraSocial={idObraSocial} setIdObraSocial={setIdObraSocial} hideTitle={true} />
          </Grid>
          <Grid item xs={12} md={3}>
            <Grid
              container
              spacing={3}
              style={{ display: "flex", padding: 5 }}
            >
              <Grid item xs={12} md={12} >
                <Paper className={classes.input}>
                  <BuscadorMedicamento
                    label="Medicamento (Present. | Lab. | Nombre | Drogas)"
                    fieldsDisabled={false}
                    autorizacion={true}
                    setCod={(val) => setCodigoMedicamento(val)}
                  />
                </Paper>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={2}>
            <Paper className={classes.input}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  label="Fecha Inicio"
                  format="dd/MM/yyyy"
                  required={true}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  value={
                    moment(fechaInicio).isValid() ? moment(fechaInicio) : null
                  }
                  onChange={(date) => {
                    setearValor("fechaInicio", date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Paper>
          </Grid>
          <Grid item xs={12} md={2}>
            <Paper className={classes.input}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  label="Fecha Fin"
                  format="dd/MM/yyyy"
                  required={true}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  value={moment(fechaFin).isValid() ? moment(fechaFin) : null}
                  onChange={(date) => {
                    setearValor("fechaFin", date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Paper style={{ padding: "0.25rem" }}>
          <RadioGroup
            row
            style={{ justifyContent: "space-around" }}
            value={estadoRecetas}
            onChange={(e) => {
              dispatch(setEstadoRecetas(e.target.value));
            }}
          >
            {arrayEstadosRecetas.map((estadoReceta) => {
              const contador = recetasContadores.find(s => s.idEstado === estadoReceta[1]);
              const label =
                estadoReceta[0].charAt(0) +
                estadoReceta[0].replace("_", " ").toLowerCase().slice(1) +
                ((contador && contador !== undefined)
                  ?
                  `(${contador.total})`
                  :
                  `(...)`
                );
              return (
                <FormControlLabel
                  key={estadoReceta[1]?.toString()}
                  style={{ marginLeft: "0.5rem" }}
                  label={label}
                  value={estadoReceta[1]?.toString()}
                  control={<Radio />}
                />
              );
            })}
          </RadioGroup>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <TableContainer component={Paper} style={{ overflowX: "auto" }}>
          <Table size={dense ? "small" : "medium"} ref={componentRef}>
            <TableHead>
              <TableRow>
                <TableCell align="left">Fecha</TableCell>
                <TableCell align="left">N° Receta</TableCell>
                <TableCell align="left">Tipo Receta</TableCell>
                <TableCell align="left">Duplicada</TableCell>
                <TableCell align="left">Subtipo Receta</TableCell>
                <TableCell align="left">Trat. Prolon.</TableCell>
                <TableCell align="left">Diagnostico</TableCell>
                <TableCell align="left">Medicamentos</TableCell>
                <TableCell align="left">Paciente</TableCell>
                <TableCell align="left">N° Afiliado</TableCell>
                <TableCell align="left"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.length > 0 ? (
                // items.map((item) => (
                items
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item) => (
                    <RecetaItem
                      item={item}
                      setRedirect={setRedirect}
                      permisosUser={permisosUser}
                      key={item.idRecetaDigital?.toString()}
                      estadoRecetas={estadoRecetas}
                      expandirMedicamentos={false}
                      {...props}
                    />
                  ))
              ) : (
                <TableRow style={{ height: 50 }}>
                  <TableCell
                    colSpan={13}
                    style={{ textAlign: "-webkit-center" }}
                  >
                    {" "}
                    Sin Registros
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      {items.length > 0 && (
        <Grid item xs={12}>
          <TablePagination
            style={{ backgroundColor: "white" }}
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={items.length}
            rowsPerPage={rowsPerPage}
            labelRowsPerPage="Registros por página"
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
          <FormControlLabel
            control={
              <Switch
                checked={dense}
                onChange={(e) => setDense(e.target.checked)}
              />
            }
            label="Tamaño compacto"
          />
        </Grid>
      )}
      {redirect && (
        <Redirect
          to={{
            pathname: '/recetasDigitales',
            state: {
              from: '/recetasDigitales/gestion'
            },
          }}
        />
      )}
    </Grid>
  );
};
